import React, { useContext as useContextCore } from 'react'

export type ConfirmDialogIcon = 'warning' | 'error' | 'success' | 'info'

export type ConfirmDialogButtons = {
  cancel?: string | false
  confirm?: { text?: string; value?: any }
  [key: string]: any
}

export type ConfirmDialogConfig = {
  title?: string
  text?: string
  icon?: ConfirmDialogIcon | string
  dangerMode?: boolean
  buttons?: ConfirmDialogButtons
  component?: React.ReactNode
  content?: 'input'
}

export type ConfirmDialogRequest = ConfirmDialogConfig & {
  resolve: (value: any) => void
  promptValueRef?: React.MutableRefObject<string>
}

export type ConfirmDialogContextType = {
  showDialog: (config: ConfirmDialogConfig, promptValueRef?: React.MutableRefObject<string>) => Promise<any>
}

const context = React.createContext<ConfirmDialogContextType>({} as ConfirmDialogContextType)

export const ConfirmDialogContextProvider = context.Provider

export const useConfirmDialogContext = () => useContextCore(context)
